/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
"use strict";
/**
 * Used to load ng moduled factories.
 * @experimental
 */
var NgModuleFactoryLoader = (function () {
    function NgModuleFactoryLoader() {
    }
    return NgModuleFactoryLoader;
}());
exports.NgModuleFactoryLoader = NgModuleFactoryLoader;
//# sourceMappingURL=ng_module_factory_loader.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@angular/core/src/linker/ng_module_factory_loader.js
 ** module id = 95
 ** module chunks = 2
 **/